import Axios from "axios";

export class api {
	// O sustenido/hastag/jogo da velha, representa que a variável é privada.
	#headers = {
		"Content-Type": "application/json",
		Accept: "application/json",
	};

	async post(GET_BASE_URL, endpoint, data = null, header = {}) {
		let result;
		const url = GET_BASE_URL + endpoint;
		try {
			const headers = this.#headers;
			if (header) {
				Object.entries(header).forEach(([key, value]) => {
					headers[key] = value;
				});
			}

			const response = await Axios.post(url, data, {
				headers,
				withCredentials: true,
			});
			result = response.data;
		} catch (error) {
			result = error.response;
			this.#catchError(error, endpoint);
		} finally {
			return result;
		}
	}

	async get(GET_BASE_URL, endpoint, withCredentials = true, header = {}) {
		let result;
		const url = GET_BASE_URL + endpoint;
		try {
			const headers = this.#headers;
			if (header) {
				Object.entries(header).forEach(([key, value]) => {
					headers[key] = value;
				});
			}

			const response = await Axios.get(url, {
				headers,
				withCredentials,
			});
			result = response.data;
		} catch (error) {
			result = error.response;
			this.#catchError(error, endpoint);
		} finally {
			return result;
		}
	}

	#catchError = (error, endpoint) => {
		console.error(
			`[${String(endpoint).split("/")[2].toUpperCase()} ERROR] ->`,
			error || `Houve um erro ao chamar o endpoint ${String(endpoint).toUpperCase()}`
		);

		if (Boolean(error) && error.response.status === 401) {
			toast.error("Sua sessão expirou, faça login novamente.");
			history.push("/onboard/login");
		}
	};
}
